import {createReducer, createAction} from '@reduxjs/toolkit'
import {OrderType} from '../../props_reusable/order_details'
import {
  BookedSlotDetails,
  Coordinate,
  ShippingAddressDetails,
} from '../../props_reusable/visit'
import util from '../../utils'

export interface DateScreenModalPayload {
  type: null | 'BOOK' | 'CHANGE' | 'RESCHEDULE'
  visitId: null | number
  bookedSlotDetail: null | BookedSlotDetails
  visitType: null | OrderType
  isShipmentFailed: boolean
}

interface ModalState {
  showModal: boolean
  type:
    | null
    | 'SPECIAL_INSTRUCTION'
    | 'BEST_DATE'
    | 'STANDARD_DATE_CHOICE'
    | 'LOCATION'
    | 'NOTIFY_PREFS'
  data: {
    specialInstruction: {
      type: null | 'EDIT' | 'ADD'
      content: string
      redirectedFrom: null | 'DATE_SCREEN'
      visitId: null | number
    }
    bestDate: DateScreenModalPayload
    standardDateChoice: DateScreenModalPayload
    location: {
      visitId: null | number
      addressDetails: null | ShippingAddressDetails
      coordinate: null | Coordinate
    }
    notifyPrefs: {
      visitId: null | number
      email: null | string
      phone: null | string
    }
  }
}

const modalInitialState: ModalState = {
  showModal: false,
  type: null,
  data: {
    specialInstruction: {
      type: null,
      content: '',
      redirectedFrom: null,
      visitId: null,
    },
    bestDate: {
      type: null,
      visitId: null,
      bookedSlotDetail: null,
      visitType: null,
      isShipmentFailed: false,
    },
    standardDateChoice: {
      type: null,
      visitId: null,
      bookedSlotDetail: null,
      visitType: null,
      isShipmentFailed: false,
    },
    location: {
      visitId: null,
      addressDetails: null,
      coordinate: null,
    },
    notifyPrefs: {
      visitId: null,
      email: null,
      phone: null,
    },
  },
}

export const showSpecialInstructionModal = createAction(
  'SHOW_SPECIAL_INSTRUCTION',
  function (d: typeof modalInitialState.data.specialInstruction) {
    return {
      payload: d,
    }
  },
)

export const showBestDateModal = createAction(
  'SHOW_BEST_DATE',
  function (d: typeof modalInitialState.data.bestDate) {
    return {
      payload: d,
    }
  },
)

export const showStandardDateChoiceModal = createAction(
  'SHOW_STANDARD_DATE_CHOICE',
  function (d: typeof modalInitialState.data.standardDateChoice) {
    return {
      payload: d,
    }
  },
)

export const showLocationModal = createAction(
  'SHOW_LOCATION',
  function (d: typeof modalInitialState.data.location) {
    return {
      payload: d,
    }
  },
)

export const showNotifyPrefsModal = createAction(
  'NOTIFY_PREFS',
  function (d: typeof modalInitialState.data.notifyPrefs) {
    return {
      payload: d,
    }
  },
)

export const hideModal = createAction('HIDE_MODAL')

const modalReducer = createReducer(modalInitialState, builder => {
  builder.addCase(showSpecialInstructionModal, (state, action) => {
    util.toggleRoot('0')
    return {
      ...state,
      showModal: true,
      type: 'SPECIAL_INSTRUCTION',
      data: {...state.data, specialInstruction: action.payload},
    }
  })
  builder.addCase(showBestDateModal, (state, action) => {
    util.toggleRoot('0')
    return {
      ...state,
      showModal: true,
      type: 'BEST_DATE',
      data: {...state.data, bestDate: action.payload},
    }
  })
  builder.addCase(showStandardDateChoiceModal, (state, action) => {
    util.toggleRoot('0')
    return {
      ...state,
      showModal: true,
      type: 'STANDARD_DATE_CHOICE',
      data: {...state.data, standardDateChoice: action.payload},
    }
  })
  builder.addCase(showLocationModal, (state, action) => {
    util.toggleRoot('0')
    return {
      ...state,
      showModal: true,
      type: 'LOCATION',
      data: {...state.data, location: action.payload},
    }
  })
  builder.addCase(showNotifyPrefsModal, (state, action) => {
    util.toggleRoot('0')
    return {
      ...state,
      showModal: true,
      type: 'NOTIFY_PREFS',
      data: {...state.data, notifyPrefs: action.payload},
    }
  })
  builder.addCase(hideModal, () => {
    util.toggleRoot('1')
    return {
      ...modalInitialState,
    }
  })
})

export default modalReducer
